import * as React from "react";
const SvgClockFilledIcon = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", "data-icon": "clockFilled", role: "img", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.444 3.685a10 10 0 1 1 11.112 16.63A10 10 0 0 1 6.444 3.685M15.1 12.63 13 11.42V7a1 1 0 0 0-2 0v5.12a.7.7 0 0 0 .05.2q.03.09.08.17.04.085.1.16l.16.13.09.09 2.6 1.5a1 1 0 0 0 .5.13 1 1 0 0 0 .5-1.87z", clipRule: "evenodd" }));
export default SvgClockFilledIcon;
